module.exports = __webpack_public_path__ + "79a26baa4d1539fdfb30b671cd10acba.png";